type SearchQueryType = "project" | "task" | "milestone";

type SearchQuery = {
  types?: SearchQueryType[];
  name: string;
  start: number;
  limit: number;
  includeAllProjects?: boolean;
};

const searchQuery: SearchQuery = {
  name: "",
  start: 0,
  limit: 0,
};

export type { SearchQuery, SearchQueryType };

export { searchQuery };
